var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('DataTableMain',{attrs:{"datatable":_vm.table,"on-success":_vm.btnAction}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }